import { generateDialogParams } from '@/lib/generic.utils'
import { DataService, ImportsService } from '@api/index'
import router from '@router'

const SERVICE = new DataService('title-lists')

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateAll', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.get(params)
        .then(response => {
          context.commit('updateSingle', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteConfirmation(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getDeleteConfirmation(params)
        .then(response => {
          context.commit(
            'updateGlobalDialogContent',
            generateDialogParams(params.dialogUid, 'deleteSingle', response.data),
            { root: true }
          )
          context.commit('updateGlobalDialogVisibility', { uid: params.dialogUid, value: true }, { root: true })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.delete(params)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getProductTitleListImportData(context, params) {
    const endpoint = `imports/products/${params.id}/title-lists`
    const SERVICE = new DataService(endpoint)
    return new Promise((resolve, reject) => {
      return SERVICE.getCreateFormData()
        .then(response => {
          let result = response.data.result
          let mapping = {}
          result.kbartColumns.map((column, index) => {
            mapping[column] = result.sheetLetters[index]
          })
          let data = Object.assign(result, { columnsMapping: mapping })
          context.commit('updateProductTitleListImportData', data)
          resolve()
        })
        .catch(err => reject(err))
    })
  },
  getManualCreateData(context) {
    const endpoint = `publications`
    const SERVICE = new DataService(endpoint)
    return new Promise((resolve, reject) => {
      return SERVICE.getCreateFormData()
        .then(response => {
          let result = response.data.result
          context.commit('updateProductTitleListManualData', result)
          resolve()
        })
        .catch(err => reject(err))
    })
  },
  processProductTitleList(context, params) {
    const endpoint = `imports/products/${params.id}/title-lists`
    const SERVICE = new ImportsService(endpoint)
    return new Promise((resolve, reject) => {
      return SERVICE.process(params)
        .then(response => {
          router.push(response.data.result.links.self)
          resolve(response.result)
        })
        .catch(err => reject(err))
    })
  },
  create(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.create(params)
        .then(response => {
          if (response.data.status === 'positive') {
            setTimeout(() => {
              router.push(params.next)
            }, 2000)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  update(context, params) {
    return SERVICE.update(params)
      .then(response => response.data.result)
      .catch(err => err)
  },
  patch(context, params) {
    return new Promise(resolve => {
      return SERVICE.patch(params).then(response => {
        resolve(response.data.result)
      })
    })
  },
  saveManual(context, params) {
    const SERVICE = new DataService(`products/${params.product.id}/title-lists`)
    return SERVICE.create(params).then(response => {
      if (response.data.status === 'positive') {
        setTimeout(() => {
          router.push({
            name: params.next.name,
            params: { id: response.data.result.id }
          })
        }, 2000)
      }
    })
  },
  copy(context, params) {
    return SERVICE.copy(params)
  }
}
